import { render, staticRenderFns } from "./glgview.vue?vue&type=template&id=2244897d&"
import script from "./glgview.vue?vue&type=script&lang=js&"
export * from "./glgview.vue?vue&type=script&lang=js&"
import style0 from "./glgview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports